import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLogmeinComponent } from './simple-icons-logmein.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLogmeinComponent ],
    exports:      [ SimpleIconsLogmeinComponent ],
    bootstrap:    []
})
export class SimpleIconsLogmeinModule {}
